import React from 'react';
import { Badge, Card, Col, Row, Table } from 'react-bootstrap';
import './DashboardExtraKpis.css';

const badgeVariantMap = {
    primary: 'primary',
    success: 'success',
    warning: 'warning',
    danger: 'danger',
    info: 'info',
    secondary: 'secondary',
    dark: 'dark'
};

const KpiCard = ({ item }) => (
    <Card className="kpi-stat-card">
        <Card.Body>
            <div className="kpi-stat-label">{item.title}</div>
            <div className="kpi-stat-value">{item.value}</div>
            <Badge bg={badgeVariantMap[item.accent] || 'secondary'}>{item.title}</Badge>
        </Card.Body>
    </Card>
);

const RankingCard = ({ title, items }) => (
    <Card className="kpi-table-card">
        <Card.Body>
            <Card.Title className="kpi-section-title" as="h5">{title}</Card.Title>
            <Table responsive hover size="sm" className="mt-3">
                <thead>
                    <tr>
                        <th>Indicador</th>
                        <th className="text-end">Total</th>
                    </tr>
                </thead>
                <tbody>
                    {items.length > 0 ? items.map((item) => (
                        <tr key={`${title}-${item.label}`}>
                            <td>{item.label}</td>
                            <td className="text-end fw-bold">{item.total}</td>
                        </tr>
                    )) : (
                        <tr>
                            <td colSpan={2} className="text-center text-muted">Sem dados suficientes.</td>
                        </tr>
                    )}
                </tbody>
            </Table>
        </Card.Body>
    </Card>
);

const DashboardExtraKpis = ({ title, subtitle, cards, validityCards, rankings, cutoffDateLabel }) => {
    if ((!cards || cards.length === 0) && (!validityCards || validityCards.length === 0) && (!rankings || rankings.length === 0)) {
        return null;
    }

    return (
        <Card className="kpi-section-card mt-4">
            <Card.Body>
                <div className="d-flex flex-column flex-lg-row justify-content-between align-items-lg-center gap-2 mb-3">
                    <div>
                        <Card.Title className="kpi-section-title" as="h4">{title}</Card.Title>
                        <p className="kpi-section-subtitle">{subtitle}</p>
                    </div>
                    {cutoffDateLabel ? <Badge bg="light" text="dark">Corte de validade: {cutoffDateLabel}</Badge> : null}
                </div>

                {!!cards?.length && (
                    <div className="kpi-grid">
                        {cards.map((item) => (
                            <KpiCard key={item.title} item={item} />
                        ))}
                    </div>
                )}

                {!!validityCards?.length && (
                    <>
                        <Card.Title className="kpi-section-title mt-4" as="h5">Validade dos laudos aprovados por prazo</Card.Title>
                        <p className="kpi-section-subtitle">Considera apenas resultados `APROVADO 3/6/12 MESES` com inspeção a partir da data de corte.</p>
                        <div className="kpi-grid mt-3">
                            {validityCards.map((item) => (
                                <KpiCard key={item.title} item={item} />
                            ))}
                        </div>
                    </>
                )}

                {!!rankings?.length && (
                    <Row className="mt-4 g-3">
                        {rankings.map((ranking) => (
                            <Col key={ranking.title} lg={4} md={6}>
                                <RankingCard title={ranking.title} items={ranking.items} />
                            </Col>
                        ))}
                    </Row>
                )}
            </Card.Body>
        </Card>
    );
};

export default DashboardExtraKpis;
